import { IWorkShiftTimeSlot } from "../workShiftTimeSlot/workShiftTimeSlot";

export interface WorkShiftDto {
    effectiveDate: string;
    startTime: string;
    endTime: string;
    workShiftTimeSlots: IWorkShiftTimeSlot[];
    startTimeZoneName: string;
    startTimePlannedWorkShiftId?: string;
}

export interface WorkShift {
    effectiveDate: string;
    startTime: string;
    endTime: string;
    workShiftTimeSlotIds: string[];
    startTimeZoneName: string;
    startTimePlannedWorkShiftId?: string;
}

export const getWorkShift = ({
    effectiveDate,
    startTime,
    endTime,
    workShiftTimeSlots,
    startTimeZoneName,
    startTimePlannedWorkShiftId
}: WorkShiftDto) => ({
    effectiveDate,
    startTime,
    endTime,
    workShiftTimeSlotIds: workShiftTimeSlots.map((s) => s.id),
    startTimeZoneName,
    startTimePlannedWorkShiftId
});
